const VideoIcon = (props) => {
    return (
        <svg className={props.className} width="54" height="54" viewBox="0 0 54 54" fill="none" stroke="#486F88" xmlns="http://www.w3.org/2000/svg">
            <path d="M43.214 19.02L32.646 26.569L43.214 34.108V19.02Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.02 16.001H29.628C30.4288 16.0012 31.1967 16.3195 31.7628 16.8859C32.329 17.4522 32.647 18.2202 32.647 19.021V34.107C32.647 34.9078 32.329 35.6758 31.7628 36.2421C31.1967 36.8084 30.4288 37.1267 29.628 37.127H13.02C12.2207 37.1267 11.4541 36.8097 10.888 36.2453C10.322 35.681 10.0027 34.9153 10 34.116V19.029C9.99815 18.2291 10.3136 17.4612 10.8771 16.8936C11.4406 16.3259 12.2062 16.0049 13.006 16.001H13.02Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default VideoIcon;
